import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import TestCreateCode from "../views/TestCreateCode.vue";
import TestPay from "../views/TestPay.vue";
import Login from "../views/login.vue";
import ManagerHome from "../views/managerHome.vue";
import ChangePassword from "../views/changePassword.vue";
import ChildManage from "../views/mainManger/childManage.vue";
import EditChildAccount from "../views/mainManger/editChildAccount.vue";
import GoodsManage from "../views/mainManger/goodsManage.vue";
import BuySuccess from "../views/user/buySuccess.vue";
import codeWrong from "../views/user/codeWrong.vue";
import shopPay from "../views/user/shopPay.vue";
import PayingFail from "../views/user/payingFail.vue";
import BuildPages from "../views/childPages/buildOrder.vue";
import AddEditGoods from '../views/mainManger/addEditGoods.vue';
import orderManage from '../views/mainManger/orderManage.vue'
import AddGoods from "../views/childPages/addGoods.vue";
import OrderDetail from '../views/mainManger/orderDetail.vue';
import EditAddress from '../views/user/editAddress.vue';
import EmptyPage from '../views/user/emptyPage.vue';

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        // redirect: "/login", // 设置根路径重定向到 /home
        redirect: "/EmptyPage", // 设置根路径重定向到 /home
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: "/managerHome",
        name: "managerHome",
        component: ManagerHome,
    },
    {
        path: "/changePassword",
        name: "changePassword",
        component: ChangePassword,
    },
    {
        path: "/childManage",
        name: "childManage",
        component: ChildManage,
    },
    {
        path: "/editChildAccount",
        name: "editChildAccount",
        component: EditChildAccount,
    },
    {
        path: "/goodsManage",
        name: "goodsManage",
        component: GoodsManage,
    },
    {
        path: "/payingFail",
        name: "payingFail",
        component: PayingFail,
    },
    {
        path: "/createCode",
        name: "createCode",
        component: TestCreateCode,
    },
    {
        path: "/testPay",
        name: "testPay",
        component: TestPay,
    },
    // 以下为用户端路由表
    {
        path: "/buysuccess",
        name: "BuySuccess",
        component: BuySuccess,
    },
    {
        path: "/codewrong",
        name: "codewrong",
        component: codeWrong,
    },
    {
        path: "/shoppay",
        name: "shoppay",
        component: shopPay,
    },
    {
        path: '/orderManage',
        name: 'orderManage',
        component: orderManage
    },
    {
        path: '/orderDetail',
        name: 'orderDetail',
        component: OrderDetail
    },
    {
        path: '/editAddress',
        name: 'editAddress',
        component: EditAddress
    },
    {
        path: '/emptyPage',
        name: 'emptyPage',
        component: EmptyPage
    },
    // 子账号路由
    {
        path: "/buildPages",
        name: "buildPages",
        component: BuildPages,
    },
    {
        path: "/addGoods",
        name: "addGoods",
        component: AddGoods,
    },
    {
        path: '/addEditGoods',
        name: 'addEditGoods',
        component: AddEditGoods
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
